<div class="content content-md">
  @if (settingsReady) {
    <form novalidate>
      @if (isBusy) {
        <app-overlay imgClass='cg-overlay-img'></app-overlay>
      }
      <div style="margin-top: 58px;">
        <div id="content-list" class="list list-md" >
          <div class="item item-block item-md" style="border-bottom: 1px solid #dedede !important;">
            <img src="/assets/img/navigate.png" class="img-navigate-sm" />
            <div class="input-wrapper" style="width: 100%">
              <div class="list-label label label-md" style="width: 100%;padding-left: 5px;padding-right: 5px;">
                <div class="ellipses-label"  innerHTML="{{getLabelTranslation('Current_Location')}}"></div> @if (errorMessage) {
                <label class="error">{{errorMessage}}</label>
              }
            </div>
            <div class="toggle-container">
              <div class="arrow-wrapper">
                <app-toggle-button #locationToggle (changed)="onUseGeolocationClick($event)" [isChecked]="options.useGeolocation"></app-toggle-button>
              </div>
            </div>
          </div>
        </div>
        @if (options.useGeolocation) {
          <div class="item item-block item-md" style="border-bottom: 1px solid #dedede !important;">
            <img src="/assets/img/compass.svg" class="app-icon" style="padding-left: 5px;"/>
            <div class="input-wrapper" style="width: 100%">
              <div class="list-label label label-md" style="width: 100%;padding-left: 5px;padding-right: 5px;">
                <div class="ellipses-label"  innerHTML="{{getLabelTranslation('Postal_Code')}}"></div>
              </div>
              <button id="zip-search-button" style="height: 2.5em; width: 3.75em;background-color: rgb(6, 125, 197);color: white; border-radius: 5px;margin-right: 5px;" disabled>
                <img src="/assets/img/search.svg" class="md hydrated" style="height: 75%;width:75%"/>
              </button>
            </div>
          </div>
        }
        @if (!options.useGeolocation) {
          <div class="item item-block item-md" style="border-bottom: 1px solid #dedede !important;">
            <img src="/assets/img/compass.svg" class="icon icon-md icon-md-primary item-icon app-icon" style="padding-left: 5px;"/>
            <div class="input-wrapper" style="width: 100%">
              <div class="list-label label label-md" style="width: 100%;padding-left: 5px;padding-right: 5px;">
                <div class="ellipses-label" style="display: inline; padding-right: 10px;" innerHTML="{{getLabelTranslation('Postal_Code')}}"></div>
                <input #zipCodeInput type="text" maxlength="20" style="border: 1px solid #b8b4b4; border-radius: 8px; width: 140px;" (keyup)="validatePostalCode($event)" value="{{options.zipCode}}" />
              </div>
              <button id="zip-search-button" style="height: 2.5em; width: 3.75em;background-color: rgb(6, 125, 197);color: white; border-radius: 5px;margin-right: 5px;"
                (click)="onSearch(true)" [disabled]="options.useGeolocation || !postalCodeIsValid">
                <img src="/assets/img/search.svg" class="md hydrated" style="height: 75%;width:75%"/>
              </button>
            </div>
          </div>
        }
      </div>
      <div class="ion-segment segment segment-md ">
        <button id="regions-segment" (click)="setSelectedGeographyTab('regions')" class="segment-button" [ngClass]="getActiveClassIfSelected('regions')">
          <table class="badge-table">
            <tr><td>{{getLabelTranslation('Regions')}}</td>
            <td class="badge-cell"><div id="location-settings-label-badge-regions" [ngClass]="checkIfHidden('regions')">
              <div class="badge">{{getRegionCount()}}</div>
            </div></td></tr>
          </table>
        </button>
        <button id="districts-segment" (click)="setSelectedGeographyTab('districts')" class="segment-button" [ngClass]="getActiveClassIfSelected('districts')">
          <table class="badge-table">
            <tr><td>{{getLabelTranslation('Districts')}}</td>
            <td class="badge-cell"><div id="location-settings-label-badge-regions" [ngClass]="checkIfHidden('districts')">
              <div class="badge">{{getDistrictCount()}}</div>
            </div></td></tr>
          </table>
        </button>
        <button id="branches-segment" (click)="setSelectedGeographyTab('branches')" class="segment-button" [ngClass]="getActiveClassIfSelected('branches')">
          <table class="badge-table">
            <tr><td>{{getLabelTranslation('Branches')}}</td>
            <td class="badge-cell"><div id="location-settings-label-badge-regions" [ngClass]="checkIfHidden('branches')">
              <div class="badge">{{getBranchCount()}}</div>
            </div></td></tr>
          </table>
        </button>
      </div>
    </div>
    @if (!isBusy) {
      <div class="scroll-content-geo" style="flex: none !important;">
        <div id="content-list" class="list list-md" >
          <div>
            @switch (selectedGeography) {
              @case ('branches') {
                <div>
                  @for (location of branches; track location) {
                    <button class="item item-block item-md" text-wrap="" (click)="onLocationClick(location)">
                      <div class="item-inner" >
                        <div class="input-wrapper" style="width: 100%">
                          <div class="geo-btn-container">
                            <div class="geo-btn-wrapper radio-wrapper">
                              <input type="radio" [checked]="location.isSelected" class="radio"/>
                            </div>
                          </div>
                          <div class="item-content" style="width: 100%;padding-left: 5px;padding-top: 5px; padding-bottom: 5px;" >
                            <h3>{{ location.Branch }}</h3>
                            <p>
                              <img src="/assets/img/pin.png" style="margin-right: 5px;height: 15px;width: 15px;" />
                              {{getFormattedLocation(location)}}
                              @if (showDistance) {
                                <span style="padding-left: 15px;float: right;">
                                  {{ convertToImperial(location) }}
                                </span>
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="button-effect"></div>
                    </button>
                  }
                </div>
              }
              @case ('districts') {
                <div>
                  @for (district of districts; track district) {
                    <button class="item item-block item-md" text-wrap="" (click)="onDistrictChanged(district)">
                      <div class="item-inner" >
                        <div class="input-wrapper" style="width: 100%">
                          <div class="geo-btn-container">
                            <div class="geo-btn-wrapper radio-wrapper">
                              <input type="radio" [checked]="district.isSelected" class="radio"/>
                            </div>
                          </div>
                          <div class="button-effect"></div>
                          <div class="item-content" style="width: 100%" >
                            <h3>{{ district.District || district.DistrictName }}</h3>
                          </div>
                        </div>
                        <div class="button-effect"></div>
                      </div>
                    </button>
                  }
                </div>
              }
              @case ('regions') {
                <div>
                  @for (region of regions; track region) {
                    <button class="item item-block item-md" text-wrap="" (click)="onRegionChanged(region)">
                      <div class="item-inner" >
                        <div class="input-wrapper" style="width: 100%">
                          <div class="geo-btn-container">
                            <div class="geo-btn-wrapper radio-wrapper">
                              <input type="radio" [checked]="region.isSelected" class="radio"/>
                            </div>
                          </div>
                          <div class="button-effect"></div>
                          <div class="item-content" style="width: 100%" >
                            <h3>{{ region.Region || region.RegionName }}</h3>
                          </div>
                        </div>
                        <div class="button-effect"></div>
                      </div>
                    </button>
                  }
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
  </form>
}
</div>
